import Vue from "vue";
import { getAuth } from "firebase/auth";
import Router from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout";
import AuthLayout from "@/layout/AuthLayout";
import KPILayout from "@/layout/KPILayout";
import NotFound from "@/layout/NotFoundLayout";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import axios from "axios";
import {
  isLegacyAdmin,
  isLegacyRetired,
  hasLegacyAccess,
  legacyRouteKey,
} from "./legacyAccess";
Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: "inicio",
    component: DashboardLayout,
    children: [
      {
        path: "/inicio",
        name: "inicio",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Dashboard.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/pod",
        name: "pod",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Icons.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "POD",
            newConsoleUrl: "https://consola-v2.canplast.net/pod",
          },
        },
      },
      {
        path: "/ruteador",
        name: "ruteador",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Ruteador.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/backlog",
        name: "backlog",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Backlog.vue"),
        //import(/* webpackChunkName: "demo" */ "./views/BacklogBackup.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/passwordGenerator",
        name: "passwordGenerator",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/PasswordGenerator.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Claves de Autorización",
            newConsoleUrl:
              "https://consola-v2.canplast.net/inicio?tool=authKeys",
            help: {
              option: "Claves",
              search: "Claves",
              image: "img/nueva-consola-claves.png",
              alt:
                "Menú de herramientas de la nueva consola con la opción Claves resaltada",
            },
          },
        },
      },
      {
        path: "/cobros",
        name: "cobros",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/IncomingPayments/Index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/cobrosNew",
        name: "Cobros ",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/IncomingPayments/Index.vue"),
        meta: {
          requiresAuth: true,
          permissions: [
            "leslysifuentes@canplast.com.mx",
            "alfredoreyes@canplast.com.mx",
            "estefaniasalas@canplast.com.mx",
            "brendaterrazas@canplast.com.mx",
            "dannasandoval@canplast.com.mx",
            "danielamuniz@canplast.com.mx",
            "guadalupemunoz@canplast.com.mx",
            "claragonzalez@canplast.com.mx",
            "facturacionmex@canplast.com.mx",
            "alexamendez@canplast.com.mx",
            "angelicapatricio@canplast.com.mx",
            "citlaliherrera@canplast.com.mx",
            "yolandachable@canplast.com.mx",
            "bereniceterrazas@canplast.com.mx",
            "dayanescobar@canplast.com.mx",
            "misaelrobles@canplast.com.mx",
          ],
        },
      },
      {
        path: "/produccion",
        name: "Plan de Producción",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/PlanProduccion.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Plan de Producción",
            newConsoleUrl: "https://consola-v2.canplast.net/plan-produccion",
          },
        },
      },
      {
        path: "/produccionv2",
        name: "Plan de Producción V2",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/PlanProduccionV2.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Plan de Producción",
            newConsoleUrl: "https://consola-v2.canplast.net/plan-produccion",
          },
        },
      },
      {
        path: "/conciliaciones",
        name: "conciliaciones",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Conciliaciones.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/explorador/ventas",
        name: "Explorador de ventas",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/SalesExplorer.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/nuevocliente",
        name: "Nuevo Cliente",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/NuevoCliente.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/cotizaciones/proyectos",
        name: "Cotización de Proyectos",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/QuotationProjects.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/fichastecnicas",
        beforeEnter() {
          window.open(
            "https://drive.google.com/drive/folders/1KyYzlPYxJCHc9TTD1tNL40Bu7J-XewyO",
            "_blank",
          );
        },
        name: "Fichas Técnicas",
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/solicitudcredito",
        beforeEnter() {
          window.open("https://clientes.canplast.net/credito", "_blank");
        },
        name: "Solicitud de credito",
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/purchase_orders",
        name: "Ordenes de Compra",
        component: () => import("./views/PurchaseOrders.vue"),
        children: [
          //TODO: Make nested route to select purchase order
        ],
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/purchaseOrder",
        name: "Orden de Compra",
        component: () => import("./views/PurchaseOrder.vue"),
        children: [
          //TODO: Make nested route to select purchase order
        ],
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/purchaseOrderFilterBackup",
        name: "Orden de Compra Backup",
        component: () => import("./views/PurchaseOrderFilterBackup.vue"),
        children: [
          //TODO: Make nested route to select purchase order
        ],
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/purchaseOrderFilter",
        name: "Orden de Compra ",
        component: () =>
          import("./views/PurchaseOrders/PurchaseOrderFilter.vue"),
        children: [
          //TODO: Make nested route to select purchase order
        ],
        meta: {
          requiresAuth: true,
          permissions: [
            "brendaterrazas@canplast.com.mx",
            "edricbaeza@canplast.com.mx",
            "elesbantrevizo@canplast.com.mx",
            "aaronroman@canplast.com.mx",
            "daliahernandez@canplast.com.mx",
            "alfredoreyes@canplast.com.mx",
            "yeseniaarellanes@canplast.com.mx",
            "idalyvillalobos@canplast.com.mx",
            "estefaniasalas@canplast.com.mx",
            "concepcionnuno@canplast.com.mx",
            "leslysifuentes@canplast.com.mx",
          ],
        },
      },
      {
        path: "/calendario/aduana",
        name: "Calendario Aduana",
        component: () => import("./views/STCalendar.vue"),
        children: [
          //TODO: Make nested route to select purchase order
        ],
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/manuales",
        beforeEnter() {
          window.open(
            "https://sites.google.com/canplast.com.mx/canplast-wiki/inicio",
            "_blank",
          );
        },
        name: "Manuales",
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/KPI",
        name: "kpi",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/KPI.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/crm/:cardcode",
        name: "crm-cardcode",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CRM.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/crm",
        name: "crm",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CRM.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/cumplimiento",
        name: "Cumplimiento de entregas",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Fulfillment/Index.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Cumplimiento de entregas",
            newConsoleUrl:
              "https://consola-v2.canplast.net/docs-venta/cumplimiento",
          },
        },
      },
      {
        path: "/pedidos-pendientes",
        name: "Pedidos pendientes",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/PendingOrders/Index.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Pedidos Pendientes",
            newConsoleUrl:
              "https://consola-v2.canplast.net/inicio?tool=pendingOrders",
            help: {
              option: "Pedidos pend.",
              search: "Pedidos",
              image: "img/nueva-consola-pedidos-pendientes.png",
              alt:
                "Menú de herramientas y buscador de la nueva consola con la opción Pedidos pend. resaltada",
            },
          },
        },
      },
      {
        path: "/nueva-consola",
        name: "nueva-consola",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/NewConsole.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/accesos-temporales",
        name: "Accesos temporales",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/TemporaryAccess.vue"),
        meta: {
          requiresAuth: true,
          legacyAdmin: true,
        },
      },
      {
        path: "/customers",
        name: "Catálogo de Clientes",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CRM/Customers.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/customer/:CardCode",
        name: "Expediente",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CRM/Customer.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/newQuotation",
        name: "Nueva Cotización",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CRM/NewQuotation.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/backlog-backup",
        name: "Backlog Backup",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/BacklogBackup.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/prospects",
        name: "Prospectos",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CRM/Prospects.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/invoicing",
        name: "Facturación",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Invoicing/Index.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Facturación",
            newConsoleUrl:
              "https://consola-v2.canplast.net/docs-venta/facturacion",
          },
        },
      },
      {
        path: "/delivery/:DocNum",
        name: "Facturar",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Invoicing/Delivery.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Entregas",
            newConsoleUrl:
              "https://consola-v2.canplast.net/docs-venta/entrega/:DocNum",
          },
        },
      },
      {
        path: "/invoice/:DocNum",
        name: "Factura",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Invoicing/Invoice.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Facturas",
            newConsoleUrl:
              "https://consola-v2.canplast.net/docs-venta/factura/:DocNum",
          },
        },
      },
      {
        path: "/advanceInvoice/:DocNum",
        name: "Factura de Anticipo",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Invoicing/AdvanceInvoice.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Facturas de Anticipo",
            newConsoleUrl:
              "https://consola-v2.canplast.net/docs-venta/factura-anticipo/:DocNum",
          },
        },
      },
      {
        path: "/newInvoice",
        name: "Crear Factura de Anticipo",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Invoicing/NewAdvanceInvoice.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Crear Factura de Anticipo",
            newConsoleUrl:
              "https://consola-v2.canplast.net/docs-venta/facturas-anticipo",
          },
        },
      },
      {
        path: "/returnRequests",
        name: "Creación de Notas de Crédito",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CreditNotes/Index.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Notas de Crédito",
            newConsoleUrl:
              "https://consola-v2.canplast.net/devoluciones/solicitudes",
          },
        },
      },
      {
        path: "/returnRequest/:DocNum",
        name: "Solicitud de Devolución",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CreditNotes/ReturnRequest.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Solicitudes de Devolución",
            newConsoleUrl:
              "https://consola-v2.canplast.net/docs-venta/solicitud-devolucion/:DocNum",
          },
        },
      },
      {
        path: "/creditNote/:DocNum",
        name: "Nota de Crédito",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/CreditNotes/CreditNote.vue"),
        meta: {
          requiresAuth: true,
          legacy: {
            name: "Notas de Crédito",
            newConsoleUrl:
              "https://consola-v2.canplast.net/docs-venta/nota-credito/:DocNum",
          },
        },
      },
      {
        path: "/extrusion",
        name: "Extrusión",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Extrusion/Index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/requisiciones",
        name: "Requisiciones de Compra",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/PurchaseRequisitions/Index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/recursos-graficos",
        name: "Recursos Gráficos",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/GraphicResources/Index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/solicitud-pedidos",
        name: "Solicitud de pedidos",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/SolicitudPedidos/Index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/checador",
        name: "Checador",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Checador/Index.vue"),
        meta: {
          requiresAuth: true,
          permissions: [
            "leslysifuentes@canplast.com.mx",
            "alfredoreyes@canplast.com.mx",
            "susanajuarez@canplast.com.mx",
            "mariagarcia@canplast.com.mx",
            "ofelialujan@canplast.com.mx",
          ],
          legacy: {
            name: "Checador",
            newConsoleUrl: "https://consola-v2.canplast.net/asistencia",
          },
        },
      },
      {
        path: "/muestrarios",
        name: "Muestrarios",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/SwatchBooks/Index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/KPIScreen",
    redirect: "KPIScreen",
    component: KPILayout,
    children: [
      {
        path: "/KPIScreen",
        name: "KPI Screen",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/KPIScreen.vue"),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Login.vue"),
      },
      {
        path: "/register",
        name: "register",
        component: () =>
          import(/* webpackChunkName: "demo" */ "./views/Register.vue"),
      },
    ],
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: {
      requiresAuth: false,
    },
  },
];

const router = new Router({
  linkExactActiveClass: "active",
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const auth = getAuth();
  const db = getFirestore();
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

  const permission =
    (to.meta.permissions && to.meta.permissions.includes(currentUser.email)) ||
    !to.meta.permissions;

  if (currentUser && permission) {
    axios
      .post(`/api/login`, { email: currentUser.email })
      .then((result) => {
        axios.defaults.headers.common["Authorization"] = result.data.token;
        try {
          heap.identify(currentUser.uid);
          heap.addUserProperties({
            Name: currentUser.displayName,
            Email: currentUser.email,
          });
        } catch (error) {
          console.error("Error:", error);
        }
        if (!requiresAuth) {
          next("inicio");
        } else {
          if (to.meta.legacy && isLegacyRetired()) {
            hasLegacyAccess(currentUser.email, legacyRouteKey(to))
              .then((allowed) => {
                if (allowed) {
                  next();
                } else {
                  next({ name: "nueva-consola", query: { from: to.path } });
                }
              })
              .catch((error) => {
                console.error("Error al validar el acceso temporal: ", error);
                next({ name: "nueva-consola", query: { from: to.path } });
              });
          } else if (to.meta.legacyAdmin) {
            isLegacyAdmin(currentUser.email)
              .then((admin) => (admin ? next() : next("inicio")))
              .catch((error) => {
                console.error("Error al validar el administrador: ", error);
                next("inicio");
              });
          } else if (to.path === "/requisiciones") {
            // ... lógica existente ...
            const requisitionsQuery = query(
              collection(db, "purchase_requisitions_users"),
              where("email", "==", currentUser.email),
            );

            // Ejecuta la consulta
            getDocs(requisitionsQuery)
              .then((querySnapshot) => {
                if (querySnapshot.empty) {
                  next("inicio");
                } else {
                  next();
                }
              })
              .catch((error) => {
                console.error("Error al obtener documentos: ", error);
              });
          } else {
            next();
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  } else {
    if (requiresAuth) {
      next("login");
    } else {
      next();
    }
  }
});

export default router;
